import axios from 'axios'
import Qs from 'qs'
import router from '../router/index'
import { getToken, removeToken } from '@/utils/auth'


function request(data) {
  let instance = axios.create({
    baseURL: process.env.BASE_API,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      'authorization': localStorage.getItem('token'),
      // 'authorization': getToken(),
    },
  })
  instance.interceptors.response.use(res => {
    if(res.data.code==410){
      removeToken();
      this.$fun.getCpAppConfig();
      // localStorage.removeItem('token')
      // router.push('/logOut');
    }
    return res
  },
    error => {
      //alert('请求失败，请稍后重试！')
      return Promise.reject(error)
    }
  )

  instance({
    method: data.method,
    url: data.url,
    data: Qs.stringify(data.data),
    params: data.params
  })
  .then(res => {
    data.success(res)
  })
  .catch(error => {
    console.log(error);
    // data.error(error)
  })
}

export default request



// WEBPACK FOOTER //
// ./src/utils/requestAxios.js